import React, { FC } from 'react'
import { useField, useFormikContext } from 'formik'
import { FormLabel, FormLabelProps, Span } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import FormFieldError from 'components/FormFieldError'
import { Editor } from 'components/Editor/Editor'

export interface RichTextFieldProps {
  name: string
  label?: string
  className?: string
  required?: boolean
  disabled?: boolean
  explanation?: string
  weight?: FormLabelProps['weight']
  imageTool?: boolean
  onChange?: (html: string) => void
}

export const FormRichTextField: FC<RichTextFieldProps> = ({
  name,
  label,
  className,
  required = false,
  disabled = false,
  explanation,
  weight = 'bold',
  imageTool = false,
  onChange,
}) => {
  const [field, meta] = useField<string>(name)
  const { setFieldValue, setFieldTouched } = useFormikContext()
  const { t } = useTranslation('common')
  const length = field.value ? field.value.length : 0

  return (
    <div className={className} onBlur={() => setFieldTouched(name, true)}>
      {label && (
        <FormLabel for={name} required={required} weight={weight}>
          {label}
        </FormLabel>
      )}
      <Editor
        key={name}
        html={field.value}
        onChange={async (html) => {
          await setFieldValue(name, html)
          await setFieldTouched(name, true, false)
          onChange?.(html)
        }}
        {...(disabled ? { readOnly: true } : {})}
        {...(imageTool ? {} : { imageTool: false })}
      />
      {length > 2900 && (
        <div
          className={`text-right mt-2 text-xs ${
            length >= 3000 ? 'text-common-red-5' : 'text-common-gray-5'
          }`}
        >
          {t('charactersRemaining', { count: 3000 - length })}
        </div>
      )}
      {explanation && <Span smallest>{explanation}</Span>}
      <FormFieldError meta={meta} />
    </div>
  )
}
